import { defineMessages, FormattedMessage } from 'react-intl'

const messages = defineMessages({
  pleaseWait: {
    id: 'order.screen.wait',
    defaultMessage: 'Please wait!',
  },
  orderProcessing: {
    id: 'order.screen.orderProcessing',
    defaultMessage: `Your credit card is currently being authenticated for security. This process helps protect you. Please wait for the page to reload. If you have any issues or the page does not reload, please contact us at <link>travel@padi.com</link> and we'll ensure your booking goes through smoothly.`,
  },
})
export default function CheckoutProcessing() {
  return (
    <div className='congrats shadow-block'>
      <h2>
        <FormattedMessage {...messages.pleaseWait} />
      </h2>
      <p className='mtm'>
        <FormattedMessage
          {...messages.orderProcessing}
          values={{
            link: (chunks) => <a href='mailto:travel@padi.com'>{chunks}</a>,
          }}
        />
      </p>
    </div>
  )
}
